import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  imageUrl: string;
  date: string;
  readTime: string;
  categoryName?: string;
}

export default function ArticleCard({ slug, title, excerpt, imageUrl, date, readTime, categoryName }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all hover:border-primary-200 cursor-pointer"
    >
      <div className="aspect-[16/9] overflow-hidden">
        <img
          src={imageUrl}
          alt={title}
          title={`${title} - 害羞草指南`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-3 mb-2">
          {categoryName && (
            <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full">
              {categoryName}
            </span>
          )}
          <span className="text-xs text-foreground-400">{date}</span>
          <span className="text-xs text-foreground-400">{readTime}</span>
        </div>
        <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
          {title}
        </h3>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
          {excerpt}
        </p>
      </div>
    </Link>
  );
}